import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initAdvSlider = function() {
  if (document.documentElement.clientWidth <= 1199) {
    const sliderAdv = document.querySelector('[data-slider-adv="slider"]');

    if (!sliderAdv) {
      return;
    }

    const sliderPagination = sliderAdv.querySelector('[data-slider-adv="pagination"]');

    const swiperAdv = function() {
      new Swiper(sliderAdv, {
          spaceBetween: 10,
          slidesPerView: 2,
          slidesPerGroup: 2,
          pagination: {
            el: sliderPagination,
            clickable: true,
            dynamicBullets: true
          },
          breakpoints: {
            360: {
              slidesPerView: 2,
              slidesPerGroup: 2
            },
            768: {
              slidesPerView: 4,
              slidesPerGroup: 4
            },
            1500: {
              slidesPerView: 6,
              slidesPerGroup: 6,
              spaceBetween: 9
            }

          }
        }
      );
    }
    swiperAdv();
  }
};
